


















































import { Component, Prop, Vue } from "vue-property-decorator";
// types
import { Status, VscFile } from "@/services/files/types";
import { FolderEntites } from "@/services/folders/types";
import i18n from "@/i18n";
// components
import DirectFileUpload from "@/components/common/files/DirectFileUpload.vue";

@Component({
    components: {
        DirectFileUpload
    }
})
export default class DirectFileUploadControl extends Vue {
    @Prop() fileTypes!: string[];
    @Prop() folder!: FolderEntites;

    // local state
    fileStatus = Status;
    vscFile = {} as VscFile;

    // computed
    get uploadButton() {
        if ((!this.fileTypes || this.fileTypes.length === 0) || this.fileTypes.length > 1) {
            return i18n.t("file.uploadFile");
        }

        const fileType = this.fileTypes[0];

        switch (fileType) {
        case "Image":
            return i18n.t("posts.image.uploadImage");
        case "Video":
            return i18n.t("posts.video.uploadVideo");
        default:
            return i18n.t("file.uploadFile");
        }
    }

    // methods

    openFileUpload(): void {
        (this.$refs.directUpload as any).openFileUpload();
    }

    toggleHeaderButtons(state: boolean) {
        this.$emit("toggleHeaderButtons", state);
    }

    retryUpload() {
        (this.$refs.directUpload as any).retryUpload();
    }

    removeFile() {
        (this.$refs.directUpload as any).removeFile();
    }

    fileUploaded(file: any) {
        this.$emit("fileUploaded", file);
    }

    uploadStarted() {
        this.$emit("startUploading");
    }

    fileObjectChanged(vscFile: VscFile) {
        this.vscFile = vscFile;
    }
}
